module.exports = __webpack_public_path__ + "static/img/cmxc.1fd8671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cmxc.jpg
// module id = JHy5
// module chunks = 1